import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
import { scanForProducts, getRandomProduct, ScannedProduct } from '../utils/productScanner';
const NAMES = ['Sarah', 'Emily', 'Jessica', 'Amanda', 'Michelle', 'Ashley', 'Melissa', 'Nicole', 'Stephanie', 'Heather'];
const LOCATIONS = ['Texas', 'California', 'Florida', 'New York', 'Illinois', 'Pennsylvania', 'Ohio', 'Georgia', 'North Carolina', 'Michigan'];
function getRandomItem(arr: string[]) {
  return arr[Math.floor(Math.random() * arr.length)];
}
function getRandomTimeAgo() {
  const times = ['Just now', '1 min ago', '2 mins ago', '5 mins ago', '10 mins ago'];
  return getRandomItem(times);
}
export function RecentPurchaseToast() {
  const [isVisible, setIsVisible] = useState(false);
  const [productData, setProductData] = useState<ScannedProduct | null>(null);
  const [buyerName, setBuyerName] = useState('');
  const [buyerLocation, setBuyerLocation] = useState('');
  const [timeAgo, setTimeAgo] = useState('');
  const [products, setProducts] = useState<ScannedProduct[]>([]);
  useEffect(() => {
    // Scan the page for products on mount
    const scanned = scanForProducts();
    setProducts(scanned);
  }, []);
  useEffect(() => {
    if (products.length === 0) return;
    const showToast = () => {
      const product = getRandomProduct(products);
      setProductData(product);
      setBuyerName(getRandomItem(NAMES));
      setBuyerLocation(getRandomItem(LOCATIONS));
      setTimeAgo(getRandomTimeAgo());
      setIsVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Initial delay before first toast
    const initialTimer = setTimeout(showToast, 3000);
    // Then show every 15-25 seconds
    const interval = setInterval(() => {
      showToast();
    }, Math.floor(Math.random() * 10000) + 15000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, [products]);
  return <AnimatePresence data-id="element-197">
      {isVisible && productData && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 sm:bottom-6 sm:left-6 z-50 max-w-sm w-full bg-white rounded-xl shadow-2xl border border-gray-100 overflow-hidden" data-id="element-198">
          <div className="flex items-start p-4 gap-4" data-id="element-199">
            {/* Thumbnail */}
            <div className="flex-shrink-0 w-16 h-16 bg-cream rounded-lg overflow-hidden flex items-center justify-center p-1 border border-gray-100" data-id="element-200">
              <img src={productData.thumbnailUrl} alt={productData.title} className="w-full h-full object-contain" data-id="element-201" />
            </div>

            {/* Content */}
            <div className="flex-1 min-w-0" data-id="element-202">
              <div className="flex items-center justify-between mb-1" data-id="element-203">
                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-204">
                  {buyerName} from {buyerLocation}
                </p>
                <button onClick={() => setIsVisible(false)} className="text-gray-400 hover:text-gray-600 transition-colors" aria-label="Close notification" data-id="element-205">
                  <XIcon className="w-4 h-4" data-id="element-206" />
                </button>
              </div>
              <p className="text-sm font-bold text-deep-teal truncate" data-id="element-207">
                Purchased {productData.title}
              </p>
              <div className="flex items-center justify-between mt-1" data-id="element-208">
                <p className="text-xs text-gray-500" data-id="element-209">{timeAgo}</p>
                <div className="flex items-center gap-1 text-xs font-bold text-green-600 bg-green-50 px-2 py-0.5 rounded-full" data-id="element-210">
                  <CheckIcon className="w-3 h-3" data-id="element-211" />
                  Verified
                </div>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}